import React, { useEffect, useState } from 'react';

const EXAMPLE_PROMPTS = [
  'SUV unter 700 Euro',
  'Einen schwarzen Audi',
  'Blaue BMW-Limousine',
  'Großes Familienauto',
  'Stadtautos zum Rabatt',
];

interface PlaceholderTextProps {
  className?: string;
  isMobile?: boolean;
}

export const PlaceholderText: React.FC<PlaceholderTextProps> = ({
  className = '',
  isMobile,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % EXAMPLE_PROMPTS.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`relative ${className} h-9 ${isMobile && 'overflow-hidden'}`}
      id="placeholder"
    >
      {EXAMPLE_PROMPTS.map((text, index) => (
        <div
          key={index}
          className={`absolute w-full text-black transition-all duration-500 ease-in-out ${
            index === currentIndex
              ? 'translate-y-0 opacity-60'
              : index === currentIndex - 1
                ? 'translate-y-full opacity-0'
                : '-translate-y-full opacity-0'
          }`}
        >
          {text}
        </div>
      ))}
    </div>
  );
};

export default PlaceholderText;
